import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';


@Component({
	selector: 'ui-input-radio-accept',
	template: `
		<div class="ui-input-radio-accept btn-group btn-group-toggle {{readonly?'readonly':''}} {{noColors?'no-colors':'with-colors'}}"
			 data-toggle="buttons">
			<label *ngIf="!hideAccept" class="btn {{sm?'mini':''}}  btn-sm  bg-green {{cva.value===true && cva.value!==null?'active':''}}"
				   (click)="accept()"
			>
				{{textAccept}}
				<!--<i class="material-icons">done</i>-->
			</label>
			<label class="btn btn-sm  bg-red {{sm?'mini':''}} {{cva.value===false && cva.value!==null?'active':''}}"
				   (click)="reject()">
				{{textReject}}
				<!--<i class="material-icons">warning</i>-->
			</label>
		</div>

	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputRadioAcceptComponent),
			multi: true
		}
	]
})
export class UIInputRadioAcceptComponent extends CVA {
	@Input() name;
	@Input() noColors = false;
	@Input() readonly = false;
	@Input() textAccept = 'Accept';
	@Input() textReject = 'Reject';
	@Input() hideAccept = false;
	@Input() sm = false;
	@Output() changed = new EventEmitter();

	public accept() {
		this.set(true);
	}

	public reject() {
		this.set(false);
	}

	public set(val) {
		if (!this.readonly) {
			this.writeValueFromInput(val);
			this.changed.emit(val);
		}
	}

	writeValue(obj: any) {
		this.cva.value = obj;
		this.cva.onChangeFunction(obj);
		this.cva.onTouchedFunction(obj);
	}

}
